// @flow

import range from '../range';

const cacheMap = {};

declare var Intl: Object;

const getMonths = (locale: string): Array<string> => {
  if (!cacheMap[locale]) {
    cacheMap[locale] = range(0, 12).map(monthNr => {
      const firstOfMonth = new Date(Date.UTC(2018, monthNr, 1, 0, 0, 0));
      return new Intl.DateTimeFormat(locale, { month: 'long', timeZone: 'UTC' }).format(firstOfMonth);
    });
  }

  return cacheMap[locale];
};

export default getMonths;
